import React from 'react';
import Instructions from '../Instructions/Instructions';
import {isEsimType} from '../../../../../../utilities/domain/simTypeConstants';

const ChooseLineToActivate = (props) => {
let newLines = props.cellularSettingsList?.filter(x => isEsimType(x.simType) && x.phoneType == "new");
let niudLines = props.cellularSettingsList?.filter(x => isEsimType(x.simType) && x.phoneType == "transfer");

  return (
    <div className={`choosing-line-to-activate`}>
      <Instructions details={props.instructions}/>
      <div className='phone-numbers-wrapper'>
            <div className='new-phone-numbers'>
            {newLines?.map((item, i) => {
              return(<button key={i}  onClick={() => {props.onSelectedLine(item, "new")}} className={`new-phone-number ${props.selectedLine.phoneNumber == item.phoneNumber ? 'selected' : ''}`} >
                <span className='phone-number'>{item.phoneNumberFormat}</span>
                </button>)
              })}
            {niudLines?.map((item, i) => {
              return(<button key={i}  onClick={() => {props.onSelectedLine(item, "niud")}} className={`niud-phone-number ${props.selectedLine.phoneNumber == item.phoneNumber ? 'selected' : ''}`} >
                <span className='phone-number'>{item.phoneNumberFormat}</span>
                <span className='info-text'>את ה-eSIM ניתן להפעיל רק אחרי סיום ניוד הקו {window.Config.brand_Name_HE} . הנחיות לביצוע הניוד נשלחו אליכם בהודעת SMS</span>
                </button>)
              })}
          </div>
      </div>
    </div>
  );
};

export default ChooseLineToActivate;
